// import {
//   Tooltip,
//   Modal,
//   Button,
//   Select,
//   Table,
//   Typography,
//   Image,
//   Radio,
// } from "antd";
// import { CloseOutlined } from "@ant-design/icons";
// import { useState } from "react";
// import "./BNPLModal.scss";
// import InfoIcon from "../../../../assets/Icons/infoIcon.svg";
// import alfaLogo from "../../../../assets/images/logos/logo.svg";
// import IslamicIcon from "../../../../assets/images/islamic-icon.png";
// import creaditCards from "../../../../assets/images/creditcards.png";
// import islamicImage from "../../../../assets/images/Islamic/islamic-logo.png";
// import Cookies from "js-cookie";

// const BNPLModal = ({
//   ProductTitle,
//   handleProductDiscountedPrice,
//   addProduct,
//   visible,
//   setInstallmentModalVisible,
//   AllBankPlans,
//   BAFLCardPlans,
//   selectedBAFLPlan,
//   setSelectedBAFLPlan,
//   selectedAllBankPlan,
//   setSelectedAllBankPlan,
// }) => {
//   const Text = Typography;
//   const { Option } = Select;
//   const userType = Cookies.get("user_type");
//   const mainColor = Cookies.get("main_theme");
//   const secondaryColor = Cookies.get("secondary_theme");

//   const [cardType, setCardType] = useState(null);

//   const handleBAFLPlanChange = (value) => {
//     setSelectedBAFLPlan(value);
//     setSelectedAllBankPlan(null);
//   };

//   const handleAllBankPlanChange = (value) => {
//     setSelectedAllBankPlan(value);
//     setSelectedBAFLPlan(null);
//   };

//   const handleCardTypeChange = (e) => {
//     const selectedType = e.target.value;
//     setCardType(selectedType);

//     setSelectedBAFLPlan(null);
//     setSelectedAllBankPlan(null);
//   };

//   const BAFLCardPlanOptions = BAFLCardPlans?.plans.map((plan, index) => (
//     <Option key={`bafl-plan-${index}`} value={plan}>
//       {plan}
//     </Option>
//   ));

//   const AllBankPlanOptions = AllBankPlans?.plans?.map((plan, index) => (
//     <Option key={`allbank-plan-${index}`} value={plan.value}>
//       {plan.label}
//     </Option>
//   ));

//   const dataBAFL = BAFLCardPlans?.processing_fees?.map((feeInfo, index) => ({
//     key: index,
//     plan: feeInfo.plan,
//     fee: feeInfo.fees,
//   }));

//   const dataABCC = AllBankPlans?.plan_details?.map((feeInfo, index) => ({
//     key: index,
//     plan: feeInfo.tenure,
//     product_price: `${feeInfo.product_price}`,
//     plan_installment: `PKR ${feeInfo.installment_fee}/Month`,
//   }));

//   const columnsBAFL = [
//     {
//       title: "Installment Plans",
//       dataIndex: "plan",
//       key: "plan",
//       align: "center",
//       className: "table-header",
//     },
//     {
//       title: "Processing Fees + FED (One Time)",
//       dataIndex: "fee",
//       key: "fee",
//       align: "center",
//       className: "table-header",
//     },
//   ];

//   const columnsABCC = [
//     {
//       title: "Installment Plans",
//       dataIndex: "plan",
//       key: "plan",
//       align: "center",
//       className: "table-header",
//     },
//     {
//       title: "Product Price",
//       dataIndex: "product_price",
//       key: "product_price",
//       align: "center",
//       className: "table-header",
//     },
//     {
//       title: "Monthly Installment",
//       dataIndex: "plan_installment",
//       key: "plan_installment",
//       align: "center",
//       className: "table-header",
//     },
//   ];

//   const handleCheckout = () => {
//     if (selectedBAFLPlan) {
//       addProduct(selectedBAFLPlan, { is_bnpl: true, is_bafl_plan: true });
//     } else if (selectedAllBankPlan) {
//       addProduct(selectedAllBankPlan, { is_bnpl: true, is_bafl_plan: false });
//     }
//   };

//   const hasBAFLPlans =
//     BAFLCardPlanOptions?.length > 0 && userType !== "islamic";
//   const hasAllBankPlans = AllBankPlanOptions?.length > 0;

//   return (
//     <Modal
//       open={visible}
//       onCancel={() => setInstallmentModalVisible(false)}
//       footer={null}
//       centered
//       closeIcon={<CloseOutlined style={{ color: "black" }} />}
//       bodyStyle={{
//         padding: "20px 10px",
//         opacity: 1,
//       }}
//       className="BAFL-card-modal"
//     >
//       <h2
//         style={{
//           textAlign: "left",
//           fontWeight: "500",
//           fontSize: "24px",
//           color: mainColor,
//         }}
//       >
//         {ProductTitle.split(" | ")[0]}
//       </h2>

//       <h2
//         style={{
//           textAlign: "left",
//           fontWeight: "500",
//           fontSize: "20px",
//           color: mainColor,
//         }}
//       >
//         Total Price: {handleProductDiscountedPrice}
//       </h2>

//       {/* Radio Button Selection */}
//       {(hasBAFLPlans || hasAllBankPlans) && (
//         <div style={{ marginBottom: "20px" }}>
//           <Radio.Group
//             onChange={handleCardTypeChange}
//             value={cardType}
//             style={{ width: "100%" }}
//           >
//             {hasBAFLPlans && (
//               <Radio
//                 value="bafl"
//                 style={{
//                   fontSize: "16px",
//                   fontWeight: "500",
//                   marginBottom: "10px",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     marginLeft: "8px",
//                     fontWeight: "600",
//                   }}
//                 >
//                   Bank Alfalah Credit Card
//                   <div
//                     style={{
//                       width: "3px",
//                       height: "30px",
//                       backgroundColor: "#000",
//                       margin: "0 10px",
//                     }}
//                   ></div>
//                   <Image
//                     height="auto"
//                     width={80}
//                     src={alfaLogo.src}
//                     preview={false}
//                     alt="info-icon"
//                   />
//                 </div>
//               </Radio>
//             )}
//             {/* Bank Alfalah Credit Card Section */}
//             {cardType === "bafl" && hasBAFLPlans && (
//               <>
//                 <Select
//                   value={selectedBAFLPlan || "Select Installment Plan"}
//                   onChange={handleBAFLPlanChange}
//                   dropdownClassName="custom-dropdown"
//                   style={{
//                     width: "100%",
//                     marginBottom: "10px",
//                     borderRadius: "5px",
//                     border: "none",
//                     focus: {
//                       borderColor: mainColor,
//                     },
//                   }}
//                 >
//                   {BAFLCardPlanOptions}
//                 </Select>
//                 {selectedBAFLPlan && (
//                   <Text
//                     className="font20Bold marginBottom10"
//                     style={{ textAlign: "left" }}
//                   >
//                     <span
//                       style={{
//                         color: "black",
//                         fontFamily: "ZemestroStd-Regular",
//                       }}
//                     >
//                       As Low as :{" "}
//                     </span>
//                     <span
//                       style={{
//                         fontFamily: "ZemestroStd-Medium",
//                         color: mainColor,
//                       }}
//                     >
//                       {selectedBAFLPlan?.split("Months |")[1]?.trim()}
//                     </span>
//                   </Text>
//                 )}

//                 {dataBAFL?.length > 0 ? (
//                   <Table
//                     columns={columnsBAFL}
//                     dataSource={dataBAFL}
//                     pagination={false}
//                     className="bnpl-installment-table"
//                     style={{
//                       marginBottom: "20px",
//                       border: "1px solid rgb(235, 235, 235)",
//                       borderRadius: "5px",
//                     }}
//                   />
//                 ) : null}
//                 {selectedBAFLPlan && (
//                   <div className="bnpl-helper-container">
//                     <span className="marginRight5">
//                       <Image
//                         height="auto"
//                         width={20}
//                         src={InfoIcon.src}
//                         preview={false}
//                         alt="info-icon"
//                       />
//                     </span>
//                     <p
//                       className="bnpl-helper-text font12Bold"
//                       style={{ marginTop: "2px" }}
//                     >
//                       Your instalment-based plan will be booked within 3 working
//                       days and you will see a charge of{" "}
//                       {selectedBAFLPlan?.split("/")[0]} appear in your next
//                       bill. Your card limit of PKR{" "}
//                       {handleProductDiscountedPrice} has been reserved against
//                       this purchase
//                     </p>
//                   </div>
//                 )}
//                 <div className="bnpl-helper-container">
//                   <span className="marginRight5">
//                     <Image
//                       height="auto"
//                       width={20}
//                       src={InfoIcon.src}
//                       preview={false}
//                       alt="info-icon"
//                     />
//                   </span>
//                   <p
//                     className="bnpl-helper-text font12Bold"
//                     style={{ marginTop: "2px" }}
//                   >
//                     ⁠Credit Cards within 3 months of issuance and without
//                     available limit are ineligible to avail Installments.
//                   </p>
//                 </div>
//               </>
//             )}
//             {hasAllBankPlans && (
//               <Radio
//                 value="allbank"
//                 style={{
//                   fontSize: "16px",
//                   fontWeight: "500",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     marginLeft: "8px",
//                   }}
//                 >
//                   All Bank's Credit Cards
//                   <div
//                     style={{
//                       width: "3px",
//                       height: "30px",
//                       backgroundColor: "#000",
//                       margin: "0 10px",
//                     }}
//                   ></div>
//                   <Image
//                     height="auto"
//                     width={80}
//                     src={islamicImage.src}
//                     preview={false}
//                     alt="info-icon"
//                   />
//                 </div>
//               </Radio>
//             )}
//           </Radio.Group>
//         </div>
//       )}

//       {/* All Banks Credit Cards Section */}
//       {cardType === "allbank" && hasAllBankPlans && (
//         <>
//           <Select
//             value={selectedAllBankPlan || "Select Installment Plan"}
//             onChange={handleAllBankPlanChange}
//             dropdownClassName="custom-dropdown"
//             style={{
//               width: "100%",
//               marginBottom: "10px",
//               borderRadius: "5px",
//               border: "none",
//             }}
//           >
//             {AllBankPlanOptions}
//           </Select>
//           {selectedAllBankPlan && (
//             <Text
//               className="font20Bold marginBottom10"
//               style={{ textAlign: "left" }}
//             >
//               <span
//                 style={{ color: "black", fontFamily: "ZemestroStd-Regular" }}
//               >
//                 As Low as :{" "}
//               </span>
//               <span
//                 style={{ fontFamily: "ZemestroStd-Medium", color: mainColor }}
//               >
//                 {selectedAllBankPlan.split("Months |")[1]?.trim()}
//               </span>
//             </Text>
//           )}

//           {dataABCC?.length > 0 && (
//             <Table
//               columns={columnsABCC}
//               dataSource={dataABCC}
//               pagination={false}
//               style={{
//                 marginBottom: "20px",
//                 border: "1px solid rgb(235, 235, 235)",
//                 borderRadius: "5px",
//               }}
//             />
//           )}
//           <Text
//             className="font12Bold bnpl-helper-text-container"
//             style={{ textAlign: "left", marginBottom: "20px" }}
//           >
//             <span className="marginRight5">
//               <Image
//                 height={20}
//                 src={InfoIcon.src}
//                 preview={false}
//                 alt="info-icon"
//               />
//             </span>
//             <p
//               className="bnpl-helper-text font12Bold"
//               style={{ marginTop: "2px" }}
//             >
//               All Bank's Credit Cards on 0% processing fees on all tenures
//               <br />
//               <span className="font12">
//                 {" "}
//                 Maximum Limit of up to 750K based on eligibility criteria
//               </span>
//             </p>
//           </Text>
//         </>
//       )}

//       <Button
//         onClick={handleCheckout}
//         type="primary"
//         disabled={!selectedBAFLPlan && !selectedAllBankPlan}
//         style={{
//           width: "50%",
//           margin: "auto",
//           display: "flex",
//           justifyContent: "center",
//           padding: "8px 0px 30px 0px",
//           borderRadius: "15px",
//         }}
//       >
//         Checkout
//       </Button>
//     </Modal>
//   );
// };

// export default BNPLModal;

import { Modal, Button, Select, Table, Typography, Image } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useState } from "react";
import "./BNPLModal.scss";
import InfoIcon from "../../../../assets/Icons/infoIcon.svg";
import creaditCards from "../../../../assets/images/creditcards.png";
import islamicImage from "../../../../assets/images/Islamic/islamic-logo.png";
import Cookies from "js-cookie";

const BNPLModal = ({
  ProductTitle,
  handleProductDiscountedPrice,
  addProduct,
  visible,
  setInstallmentModalVisible,
  AllBankPlans,
  BAFLCardPlans,
  selectedBAFLPlan,
  setSelectedBAFLPlan,
  selectedAllBankPlan,
  setSelectedAllBankPlan,
  selectedInterestRate,
  setSelectedInterestRate,
}) => {
  const Text = Typography;
  const { Option } = Select;
  const userType = Cookies.get("user_type");
  const mainColor = Cookies.get("main_theme");
  const currencyName = Cookies.get("defaultCurrencyName") || "PKR";

  const [isLoading, setIsLoading] = useState(false);

  // const [selectedBAFLPlan, setSelectedBAFLPlan] = useState(null);
  // const [selectedAllBankPlan, setSelectedAllBankPlan] = useState(null);

  // Set BAFL plan and clear AllBank plan
  const handleBAFLPlanChange = (value) => {
    // Find the selected plan object to get the interest rate
    const selectedPlanObj = BAFLCardPlans?.plans?.find(
      (plan) => plan.installment_plan === value
    );

    // Set only the installment_plan string
    setSelectedBAFLPlan(value);
    setSelectedAllBankPlan(null);

    // Set the interest rate for the selected plan
    if (selectedPlanObj && setSelectedInterestRate) {
      setSelectedInterestRate(selectedPlanObj.interest_rate);
    }
  };

  // Set AllBank plan and clear BAFL plan
  const handleAllBankPlanChange = (value) => {
    setSelectedAllBankPlan(value);
    setSelectedBAFLPlan(null);
  };

  const BAFLCardPlanOptions = BAFLCardPlans?.plans.map((plan, index) => (
    <Option key={`bafl-plan-${index}`} value={plan.installment_plan}>
      {plan.installment_plan}
    </Option>
  ));

  const AllBankPlanOptions = AllBankPlans?.plans?.map((plan, index) => {
    if (typeof plan === "object") {
      return (
        <Option key={`allbank-plan-${index}`} value={plan.value}>
          {plan.label}
        </Option>
      );
    }
    return (
      <Option key={`allbank-plan-${index}`} value={plan}>
        {plan}
      </Option>
    );
  });

  // const dataBAFL = BAFLCardPlans?.processing_fees?.map((feeInfo, index) => ({
  //   key: index,
  //   plan: feeInfo.plan,
  //   fee: feeInfo.fees,
  //   installment_price: feeInfo.installment_price || "N/A",
  // }));

  const dataBAFL = BAFLCardPlans?.processing_fees?.map((feeInfo, index) => {
    const monthsMatch = feeInfo.plan.match(/(\d+)\s*Months?/i);
    const months = monthsMatch ? parseInt(monthsMatch[1]) : null;

    const correspondingPlan = BAFLCardPlans?.plans?.find(
      (plan) => plan.months === months
    );

    return {
      key: index,
      plan: feeInfo.plan,
      fee: feeInfo.fees,
      installment_price: feeInfo.installment_price || "N/A",
      interest_rate: correspondingPlan?.interest_rate ?? null,
    };
  });

  const dataABCC = AllBankPlans?.processing_fees?.map((feeInfo, index) => {
    const monthsMatch = feeInfo.plan?.match(/(\d+)\s*Months?/i);
    const months = monthsMatch ? parseInt(monthsMatch[1]) : null;

    const matchingDetail = AllBankPlans?.plan_details?.find((d) => {
      const detailMonths = d.tenure?.match(/(\d+)\s*Months?/i);
      return detailMonths ? parseInt(detailMonths[1]) === months : false;
    });

    return {
      key: index,
      plan: feeInfo.plan,
      fee: feeInfo.fees,
      installment_price: matchingDetail?.installment_fee || null,
      product_price: matchingDetail?.product_price || null,
    };
  });

  const columnsBAFL = [
    {
      title: "Installment Plans",
      dataIndex: "plan",
      key: "plan",
      align: "center",
      className: "table-header",
      render: (text, record) => (
        <span>
          {text}
          {record.interest_rate === 0 ? " (0% Markup)" : " (Markup)"}
        </span>
      ),
      onCell: (record) => ({
        style: {
          backgroundColor: record.interest_rate === 0 ? "#D62314" : "white",
          color: record.interest_rate === 0 ? "white" : "black",
        },
      }),
    },
    {
      title: "Processing Fees + FED (One Time)",
      dataIndex: "fee",
      key: "fee",
      align: "center",
      className: "table-header",
      render: (text) => (
        <span style={{ color: "red", fontWeight: "500" }}>{text}</span>
      ),
    },
    {
      title: "Installment Price",
      dataIndex: "installment_price",
      key: "installment_price",
      align: "center",
      className: "table-header",
      render: (text) => <span style={{ fontWeight: "500" }}>{text ? `${currencyName} ${text}` : "—"}</span>,
    },
  ];

  const columnsABCC = [
    {
      title: "Installment Plans",
      dataIndex: "plan",
      key: "plan",
      align: "center",
      className: "table-header",
    },
    {
      title: "Product Price",
      dataIndex: "product_price",
      key: "product_price",
      align: "center",
      className: "table-header",
      render: (text) => (
        <span style={{ fontWeight: "500" }}>
          {text ? `${currencyName} ${Number(text).toLocaleString()}` : "—"}
        </span>
      ),
    },
    // {
    //   title: "Monthly Installment",
    //   dataIndex: "installment_price",
    //   key: "installment_price",
    //   align: "center",
    //   className: "table-header",
    //   render: (text) => (
    //     <span style={{ fontWeight: "500" }}>
    //       {text ? `${currencyName} ${text}/Month` : "—"}
    //     </span>
    //   ),
    // },
  ];

  const handleCheckout = async () => {
    setIsLoading(true);
    try {
      if (selectedBAFLPlan) {
        await addProduct(selectedBAFLPlan, selectedInterestRate, {
          is_bnpl: true,
          is_bafl_plan: true,
        });
      } else if (selectedAllBankPlan) {
        await addProduct(selectedAllBankPlan, null, {
          is_bnpl: true,
          is_bafl_plan: false,
        });
      }
    } catch (error) {
      console.error("Checkout error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={() => { setInstallmentModalVisible(false) }}
      footer={null}
      // title={`Total Price: ${handleProductDiscountedPrice}`}
      centered
      closeIcon={<CloseOutlined style={{ color: "black" }} />}
      bodyStyle={{
        padding: "20px 10px",
        opacity: 1,
      }}
      className="BAFL-card-modal"
    >
      <h2
        style={{
          textAlign: "left",
          fontWeight: "500",
          fontSize: "24px",
          color: mainColor,
        }}
      >
        {ProductTitle.split(" | ")[0]}
      </h2>

      <h2
        style={{
          textAlign: "left",
          fontWeight: "500",
          fontSize: "20px",
          color: mainColor,
        }}
      >
        Product Price: {currencyName} {handleProductDiscountedPrice}
      </h2>

      {BAFLCardPlanOptions?.length > 0 && userType !== "islamic" ? (
        <>
          <div className="creditCards">
            <img src={creaditCards.src} alt="creditCards" />
            <h2
              style={{
                textAlign: "left",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                lineHeight: "1",
              }}
            >
              Bank Alfalah Credit Card
            </h2>
          </div>

          <Select
            value={selectedBAFLPlan || "Select Installment Plan"}
            onChange={handleBAFLPlanChange}
            dropdownClassName="custom-dropdown"
            style={{
              width: "100%",
              marginBottom: "10px",
              borderRadius: "5px",
              border: "none",
              focus: {
                borderColor: mainColor,
              },
            }}
          >
            {BAFLCardPlanOptions}
          </Select>

          {/* {selectedBAFLPlan && (
            <Text
              className="font20Bold marginBottom10"
              style={{ textAlign: "left" }}
            >
              <span style={{ color: "black" }}>As Low as : </span>
              <span style={{ color: mainColor }}>
                {selectedBAFLPlan.split("Months |")[1]?.trim()}
              </span>
            </Text>
          )} */}

          {dataBAFL?.length > 0 ? (
            <Table
              columns={columnsBAFL}
              dataSource={dataBAFL}
              pagination={false}
              bordered={true}
              className="bnpl-installment-table"
              style={{
                marginBottom: "20px",
                border: "1px solid rgb(235, 235, 235)",
                borderRadius: "5px",
              }}
            />
          ) : null}
          {selectedBAFLPlan && (
            <div className="bnpl-helper-container">
              <span className="marginRight5">
                <Image
                  height="auto"
                  width={20}
                  src={InfoIcon.src}
                  preview={false}
                  alt="info-icon"
                />
              </span>
              <p
                className="bnpl-helper-text font12Bold"
                style={{ marginTop: "2px" }}
              >
                Your instalment-based plan will be booked within 3 working days
                and you will see a charge of {selectedBAFLPlan?.split("/")[0]}{" "}
                appear in your next bill. Your card limit of {currencyName}{" "}
                {handleProductDiscountedPrice} will be reserved against this
                purchase
              </p>
            </div>
          )}
          <div className="bnpl-helper-container">
            <span className="marginRight5">
              <Image
                height="auto"
                width={20}
                src={InfoIcon.src}
                preview={false}
                alt="info-icon"
              />
            </span>
            <p
              className="bnpl-helper-text font12Bold"
              style={{ marginTop: "2px" }}
            >
              ⁠Credit Cards within 3 months of issuance and without available
              limit are ineligible to avail Installments.
            </p>
          </div>
            <div className="bnpl-helper-container">
            <span className="marginRight5">
              <Image
                height="auto"
                width={20}
                src={InfoIcon.src}
                preview={false}
                alt="info-icon"
              />
            </span>
            <p
              className="bnpl-helper-text font12Bold"
              style={{ marginTop: "2px" }}
            >
              Effective July 1, 2026, a minimum processing fee will apply as per the latest schedule of charges — 2.5% or Rs. 1,500 (whichever is higher), plus FED.
            </p>
          </div>
        </>
      ) : null}
      {AllBankPlanOptions?.length > 0 && (
        <>
          <div className="all-banks-credicts-heading">
            <img
              src={islamicImage.src}
              alt="Islamic Logo"
              className="islamic-logo-image"
            />
            <h2>All Banks, Credit Cards</h2>
          </div>
          <Select
            value={selectedAllBankPlan || "Select Installment Plan"}
            onChange={handleAllBankPlanChange}
            dropdownClassName="custom-dropdown"
            style={{
              width: "100%",
              marginBottom: "10px",
              borderRadius: "5px",
              border: "none",
            }}
          >
            {AllBankPlanOptions}
          </Select>
          {selectedAllBankPlan && typeof selectedAllBankPlan === "string" && selectedAllBankPlan.includes("Months |") && (
            <Text
              className="font20Bold marginBottom10"
              style={{ textAlign: "left" }}
            >
              <span
                style={{ color: "black", fontFamily: "ZemestroStd-Regular" }}
              >
                As Low as :{" "}
              </span>
              <span
                style={{ fontFamily: "ZemestroStd-Medium", color: mainColor }}
              >
                {selectedAllBankPlan.split("Months |")[1]?.trim()}
              </span>
            </Text>
          )}

          {dataABCC?.length > 0 && (
            <Table
              columns={columnsABCC}
              dataSource={dataABCC}
              pagination={false}
              style={{
                marginBottom: "20px",
                border: "1px solid rgb(235, 235, 235)",
                borderRadius: "5px",
              }}
            />
          )}
          <Text
            className="font12Bold bnpl-helper-text-container"
            style={{ textAlign: "left", marginBottom: "20px" }}
          >
            <span className="marginRight5">
              <Image
                height={20}
                src={InfoIcon.src}
                preview={false}
                alt="info-icon"
              />
            </span>
            <p
              className="bnpl-helper-text font12Bold"
              style={{ marginTop: "2px" }}
            >
              All Bank's Credit Cards on 0% processing fees on all tenures
              <br />
              <span className="font12">
                {" "}
                Maximum Limit of up to 750K based on eligibility criteria
              </span>
            </p>
          </Text>
        </>
      )}
      <Button
        onClick={handleCheckout}
        type="primary"
        size="large"
        className="checkout"
        loading={isLoading}
        disabled={(!selectedBAFLPlan && !selectedAllBankPlan) || isLoading}
        style={{
          width: "50%",
          margin: "auto",
          display: "flex",
          justifyContent: "center",
          padding: "0px 0px 0px 0px",
          borderRadius: "5px !important",
        }}
      >
        {isLoading ? "Processing..." : "Checkout"}
      </Button>
    </Modal>
  );
};

export default BNPLModal;
